

const defaultFont = "'Poppins', sans-serif";
//const headingFont = "'Merriweather', serif";
const headingFont = defaultFont;

export {
    defaultFont,
    headingFont
}